if(typeof BSS_B2B != undefined) {
  setTimeout(() => {
      const quickViews = document.querySelectorAll(".modal");
      quickViews.forEach((quickView) => {
        const mutationObserver = new MutationObserver((recordList, observe) => {
            BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, true);
        });
           mutationObserver.observe(quickView, { attributes: true });
      })
  }, 5000);
}